export default {
  nav: {
    portfolio: "Widyoのポートフォリオ",
    whyme: "なぜ私を選ぶべきか？",
    education: "教育",
    experience: "経験",
    organizational: "組織",
    events: "イベント",
    portfolio_link: "ポートフォリオ",
    skills: "スキル",
    certificates: "証明書",
    awards: "賞・認定",
    contact: "お問い合わせ",
    downloadResume: "履歴書をダウンロード",
    downloadPortfolio: "ポートフォリオをダウンロード",
    letsConnect: "つながりましょう",
  },
  hero: {
    greeting: "こんにちは！",
    name: "私はWidyo Tri Cahya Utomoです",
    nickname: "Dio",
    title: "DevOpsエンジニア | データエンジニア",
    description: "Apple Developer InstituteのDevOpsエンジニア。TerraformとAnsibleでAWSインフラをコードとして自動化し、CI/CDパイプラインを構築しています。ETL/CDC、クラウド移行、データプラットフォームを含む3年間のエンタープライズデータエンジニアリング経験が基盤です。",
    downloadResume: "履歴書をダウンロード",
    contactMe: "お問い合わせ",
  },
  whyme: {
    title: "なぜ私を選ぶべきか？",
    subtitle: "DevOpsエンジニアとして私が違う理由",
    content: "私は単にデータを移動させるだけではなく、それをビジネス価値を生み出すインテリジェンスに変換します。好奇心に満ちた懐疑主義で問題に取り組み、仮説を検証し、スケーラブルで信頼性が高く、実際に成果を出すシステムを設計します。私の経験は、取り込み、ウェアハウジング、オーケストレーション、ガバナンス、パフォーマンスチューニングを含む、エンドツーエンドのデータエンジニアリングにわたります。失敗が許されないエンタープライズ環境で働いてきたため、信頼性、セキュリティ、精度は譲れません。クリーンなアーキテクチャ、効率的なパイプライン、問題を引き起こすのではなく防ぐ自動化に執着しています。40以上の業界認定資格と、AIとWeb3への将来志向のフォーカスにより、今日の要求と明日の革新のために設計されたシステムを構築します。簡単に言えば、私はインパクト、スケール、そして未来のために構築されたデータソリューションを提供します。",
  },
  tools: {
    title: "日常的に使用しているツールとテクノロジーの一部",
  },
  education: {
    title: "教育",
    subtitle: "データシステムに重点を置いたコンピュータエンジニアリングの学術基盤",
    graduated: "卒業",
    institutions: {
      maranatha: {
        name: "マラナタ・キリスト教大学",
        degree: "工学士(B.E.)、コンピュータ工学",
        highlights: [
          "GPA: 3.83",
          "関連コース：データベース、オペレーティングシステム、コンピュータネットワーク",
        ],
      },
      yosuka: {
        name: "ヨス・スダルソ高等学校 - カラワン",
        degree: "数学・理科専攻",
        status: "高校卒業証書",
      },
      akademicrypto: {
        name: "アカデミ・クリプト - タンゲラン",
        degree: "Web3とブロックチェーンの非学位プログラム",
        status: "2024年3月 - 現在",
        highlights: [
          "Web3、ブロックチェーンの基礎、分散化技術に焦点",
          "暗号経済学、スマートコントラクト、DeFiエコシステムの積極的な学習",
        ],
      },
      tradewithsuli: {
        name: "TradeWithSuli - ジャカルタ",
        degree: "金融取引と市場分析の非学位プログラム",
        status: "2025年9月 - 現在",
        highlights: [
          "ファンダメンタル分析とテクニカル分析の両方を使用した暗号通貨取引に焦点",
          "コミュニティ学習を通じて実践的な取引戦略と市場評価スキルを開発",
        ],
      },
    },
  },
  experience: {
    title: "経験",
    subtitle: "クラウドインフラの自動化、およびさまざまな業界でのエンタープライズデータエンジニアリングと技術コンサルティング",
  },
  organizational: {
    title: "組織・コミュニティ",
    subtitle: "専門組織とコミュニティでのリーダーシップと積極的な参加",
    activities: [
      {
        title: "大学でのリーダーシップ",
        organization: "マラナタ・キリスト教大学",
        role: "デジタルコンピュータラボ責任者",
        dates: "2021年4月 - 2023年4月",
        description: "ラボを主導し、プロジェクトと学生の指導を管理。",
      },
      {
        title: "暗号コミュニティ",
        organization: "アカデミ・クリプト、TradeWithSuli、Coin Kami",
        role: "アクティブメンバー",
        dates: "2023年2月 - 現在",
        description: "Web3と暗号コミュニティでのアクティブな参加者と生涯学習者。",
      },
      {
        title: "コネクトグループとマルチメディアミニストリー",
        organization: "ローズオブシャロン教会",
        role: "アクティブメンバー",
        dates: "2015年8月 - 現在",
        description: "コネクトグループの交わりとマルチメディアミニストリーでの奉仕を通じて、教会コミュニティに積極的に関与し、礼拝と創造的なメディア制作をサポート。",
      },
    ],
  },
  events: {
    title: "イベント＆ギャラリー",
    subtitle: "イベント、カンファレンス、セミナー、専門活動からの写真とハイライト",
    noImages: "画像がありません",
    maintenance: "メンテナンス中",
    maintenanceDesc: "このセクションは現在、新しいコンテンツで更新中です。後ほどご確認ください！",
  },
  portfolio: {
    title: "ポートフォリオ",
    subtitle: "Web開発とデータエンジニアリングの作品を紹介する厳選プロジェクト",
    webPortfolioTitle: "Webポートフォリオ",
    dataPortfolioTitle: "データエンジニアリングポートフォリオ",
    viewLive: "ライブビュー",
    explore: "探索",
    showMore: "もっと見る",
    showLess: "少なく表示",
    downloadPdf: "ポートフォリオをPDFでダウンロード",
    generatingPdf: "PDF生成中...",
    selectProjects: "プロジェクトを選択",
    selectAll: "すべて選択",
    cancel: "キャンセル",
    downloadSelected: "ダウンロード",
    webProjects: [
      {
        title: "Maju Cipta Karyaウェブサイト",
        description: "Maju Mapanは、エレガントなデザインと持続可能性を融合させたモダンな家具ブランドです。各作品は地元の職人によって環境に優しい素材を使って手作りされており、すべての生活空間に快適さ、バランス、温もりをもたらします。",
      },
      {
        title: "Tcuber Storeウェブサイト",
        description: "Tcuber Storeは、インドネシアで信頼されているオンラインゲームトップアッププラットフォームで、Mobile Legends、Free Fire、Roblox、Genshin Impact、Clash of Clans、PUBG Mobileなどの人気ゲーム向けに、高速で安全、手頃な価格のデジタルクレジットを提供しています。さまざまな支払い方法と迅速なサポートを提供し、スムーズなゲーム体験を保証します。",
      },
    ],
    dataProjects: [
      {
        title: "AIを使ったペンギンデータ分析",
        description: "AIを活用したインタラクティブなデータ探索ツール。自然言語の質問でペンギン種のデータを分析し、動的なチャートで洞察を視覚化します。React、Recharts、Lovable AIで構築されています。",
      },
    ],
    penguinExplorer: {
      title: "ペンギンについて質問",
      selectQuestion: "何を知りたいですか？",
      submit: "送信",
      analyzing: "分析中...",
      thinking: "考え中...",
      errorLoading: "ペンギンデータの読み込みエラー",
      errorAnalyzing: "データ分析エラー",
      rateLimitError: "レート制限を超えました。後でもう一度お試しください。",
      paymentError: "支払いが必要です。Lovable AIワークスペースにクレジットを追加してください。",
      speciesDistribution: "種の分布",
      billVsBody: "くちばしの長さと体重",
      dataTable: "データプレビュー",
      questions: [
        "どのペンギンが最も長いくちばしを持っていますか？",
        "最も重いペンギンはどこに住んでいますか？",
        "どのペンギンが最も短いフリッパーを持っていますか？",
      ],
    },
  },
  skills: {
    title: "スキル",
    subtitle: "エンタープライズデータエンジニアリングを土台にしたクラウドインフラ、自動化、CI/CD",
    categories: {
      cloud: "クラウドとインフラ",
      iac: "IaCとGitOps",
      cicd: "CI/CD",
      containers: "コンテナと可観測性",
      security: "セキュリティとネットワーク",
      databases: "データベース",
      etl: "ETLと連携",
      programming: "プログラミング",
      soft: "ソフトスキル",
    },
  },
  certificates: {
    title: "Dataiku証明書",
    subtitle: "Dataikuのデータサイエンス、機械学習、AIの専門認定",
    clickToView: "クリックして完全な証明書を表示",
    download: "ダウンロード",
    verify: "確認",
    preview: "証明書プレビュー",
  },
  awards: {
    title: "賞・認定",
    subtitle: "データプラットフォーム、クラウドインフラストラクチャ、AI技術にわたる専門認定",
    view: "表示",
  },
  contact: {
    title: "お問い合わせ",
    subtitle: "機会、コラボレーション、講演依頼を歓迎します",
    info: "連絡先情報",
    email: "メール",
    phone: "電話",
    social: "ソーシャルメディア",
    sendMessage: "メッセージを送信",
    name: "名前",
    namePlaceholder: "Masukkan nama",
    emailPlaceholder: "Masukkan email",
    message: "メッセージ",
    messagePlaceholder: "Masukkan pesan",
    send: "メッセージを送信",
    copyright: "© 2025 Widyo Tri Cahya Utomo. 全著作権所有。",
  },
  whatsapp: {
    title: "お問い合わせ",
    subtitle: "連絡方法を選択してください",
    chatbot: "AIアシスタントとチャット",
    whatsapp: "WhatsAppでメッセージ",
    defaultMessage: "こんにちはWidyo！あなたとつながりたいです。",
  },
  chatbot: {
    title: "AIアシスタント",
    welcome: "こんにちは！私はWidyoのAIアシスタントです。彼の経験、スキル、プロジェクトについての質問にお答えします。どのようにお手伝いできますか？",
    placeholder: "メッセージを入力...",
    error: "申し訳ありません、エラーが発生しました。もう一度お試しください。",
  },
};
